import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import rrulePlugin from "@fullcalendar/rrule";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import "./MainComponent.css";
import { getCalendarMeetingDetails } from "../store/actions";
import { useNavigate } from "react-router-dom";
import NewMeeting from "./NewMeeting";
import Alert from "./Alert";
import BISelector from "./BISelector";

const Calendar = ({ onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showMeetingPopUp, setShowMeetingPopUp] = useState(false);
  const [showNewMeetingPopUp, setShowNewMeetingPopUp] = useState(false);
  const [eventDate, setEventDate] = useState("");
  const fetchCalendarMeetingData = useSelector(
    (state) => state.fetchCalendarMeetingData
  );
  const [events, setEvents] = useState([]);
  const [selectedMeeting, setSelectedMeeting] = useState("");
  const [biData, setBiData] = useState([]);
  const isBIFetched = useSelector((state) => state.isBIFetched);
  const biDetails = useSelector((state) => state.biDetails);
  const [selectedBI, setSelectedBI] = useState(null);

  useEffect(() => {
    if (isBIFetched) {
      if (biDetails) {
        if (biDetails.ok) {
          if (biDetails.data && biDetails.data.bi_data) {
            setBiData(
              biDetails.data.bi_data.map((obj, i) => {
                if (obj.name === localStorage.getItem("bi_id")) {
                  dispatch({
                    type: "SET_SELECTED_BI",
                    payload: {
                      value: obj.name,
                      label: obj.bi_name,
                    },
                  });
                }
                return {
                  value: obj.name,
                  label: obj.bi_name,
                };
              })
            );
          }
        }
      }
    }
    return () => {};
  }, [isBIFetched]);
  useEffect(() => {
    if (localStorage.getItem("bi_id")) {
      dispatch(getCalendarMeetingDetails(localStorage.getItem("bi_id")));
    } else {
      dispatch(getCalendarMeetingDetails());
    }
  }, []);

  useEffect(() => {
    if (
      fetchCalendarMeetingData &&
      fetchCalendarMeetingData.message &&
      fetchCalendarMeetingData.message.length > 0
    ) {
      setEvents(fetchCalendarMeetingData.message);
    } else {
      setEvents([]);
    }
  }, [fetchCalendarMeetingData]);

  const handleCloseMeetingPopup = () => {
    onClose();
    setShowMeetingPopUp(false);
  };
  const handleSelect = (e) => {
    setSelectedBI(e);
    dispatch(getCalendarMeetingDetails(e.value));
  };
  const handleMeetingClick = (arg) => {
    if (arg.extendedProps.type === "General") {
      setSelectedMeeting(arg.extendedProps.meeting_id);
      setShowMeetingPopUp(true);
    } else if (arg.extendedProps.type === "Functioanl Goal") {
      setSelectedMeeting(arg.extendedProps.meeting_id);
      localStorage.setItem("bi_id", arg.extendedProps.bi_id);
      localStorage.setItem("product_id", arg.extendedProps.product_id);
      localStorage.setItem(
        "functional_goal_id",
        arg.extendedProps.imperative_id
      );
      localStorage.setItem("goal_review_id", arg.extendedProps.goal_review_id);
      navigate("/bireview");
      window.location.reload();
    } else {
      console.log("undefined");
    }
  };
  const handleDateClick = (info) => {
    setEventDate(info);
    setShowNewMeetingPopUp(true);
  };
  return (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-content"
          style={{
            padding: "20px",
            minWidth: "1200px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                minWidth: "1100px",
              }}
            >
              <FullCalendar
                plugins={[
                  dayGridPlugin,
                  timeGridPlugin,
                  interactionPlugin,
                  rrulePlugin,
                ]}
                initialView={"dayGridMonth"}
                events={events}
                eventClick={(info) => handleMeetingClick(info.event)}
                headerToolbar={{
                  start: "prev,next today",
                  center: "title",
                  end: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                eventTextColor="#FFFFFF" // Default white text for all events
                height={"85vh"}
                dayMaxEventRows={true}
                nowIndicator={true}
                dateClick={(info) => {
                  const selectedDate = new Date(info.date);
                  const currentTime = new Date();
                  selectedDate.setHours(currentTime.getHours());
                  selectedDate.setMinutes(currentTime.getMinutes());
                  selectedDate.setSeconds(currentTime.getSeconds());
                  selectedDate.setMilliseconds(currentTime.getMilliseconds());
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  if (selectedDate >= today) {
                    handleDateClick(selectedDate);
                  } else {
                    Alert.warning({
                      title: "Creating meetings for past dates is not allowed.",
                      text: "",
                      icon: "warning",
                      showConfirmButton: true,
                    });
                  }
                }}
              />
            </div>
            <AiOutlineClose
              size={24}
              onClick={handleCloseMeetingPopup}
              style={{ cursor: "pointer", marginTop: "5px" }}
            />
            <div style={{ position: "absolute", right: "250px", top: "22px" }}>
              <BISelector
                showSelector={true}
                selectedBI={selectedBI}
                biData={biData}
                handleSelect={handleSelect}
              />
            </div>
            {showMeetingPopUp && (
              <NewMeeting
                onClose={() => handleCloseMeetingPopup()}
                selectedMeeting={selectedMeeting}
                oldMeeting={true}
              />
            )}
            {showNewMeetingPopUp && (
              <NewMeeting
                onClose={() => handleCloseMeetingPopup()}
                selectedMeeting={selectedMeeting}
                eventDate={eventDate}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
